(ns ycweb.app.blitz.prereceiving.prereceiving
  (:require
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.components.forms :as forms]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.feedback :as feedback]
   [ycweb.util.core :as u]
   [ycweb.components.grid :as grid]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.components.transitions :as t]
   [ycweb.util.date :as ud]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [util.string :as str]
   [inflections.core :as inflections]
   [ycweb.components.wrapper :as w]
   [ycweb.app.dashboard.presence :as presence]))

(def ycs-steps
  (forms/setup-steps
    [{:key :choose-type :title "Prereceiving Type"}
     {:key :stockorders-pending :title "Pending Stockorder"}
     {:key :stockorder :title "YCS Number"}
     {:key :stockorder-list :title "Select YCS"}
     {:key :reject-reasons :title "Reject Reason"}
     {:key :reject-printer :title "Scan Printer"}
     {:key :stockorder-details :title "Enter YCS Details"}
     {:key :scan-location :title "Scan Location"}
     {:key :scan-printer :title "Scan Printer"}
     {:key :confirm-printed :title "Confirm Printed"}
     {:key :finished :title "Done"}]))

(defn stockorder-receivable? [stockorder-type in-expected-week?]
  (if (and (= stockorder-type "Commitment")
        (not in-expected-week?))
    false
    true))

(defmethod grid/action :prereceiving/confirm-printed-scan [app-atom {:keys [scan]} _]
  (cond
    (not (get-in @app-atom [:prereceiving :stockorder :sticker-confirmed]))
    (toaster/open-toast app-atom :warning "Confirm sticker before scanning" {})

    (not=
      (str (get-in @app-atom [:prereceiving :stockorder :refid]))
      (str/replace scan #"[^0-9]" ""))
    (toaster/open-toast app-atom :warning "YCS does not match" {})

    :else
    (t/transition-next app-atom :prereceiving/finished)))

(defmethod flow/barcode-dispatch-screen :prereceiving/confirm-printed [_ app-atom scan]
  (grid/dispatch-action app-atom :prereceiving/confirm-printed-scan {:scan scan}))

(rum/defc confirm-printed < rum/reactive [app-atom]
  (let [es-client-order (cmn/curact app-atom [:prereceiving :es-client-order])]
    (w/wrapper app-atom "Prereceiving" {:steps ycs-steps :step :confirm-printed}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Sticker"
         [:span.u-hidden-from-view " - "]
         [:span.heading__subtext (str "that you've put on the " (if es-client-order "delivery note" "invoice"))]]
        grid/barcode-icon]
       [:div.u-margin-bottom-24
        {:class (u/bem :section [:medium])}
        (feedback/action-feedback :package "" (str "The stickers are on the " (if es-client-order "delivery notes" "invoices"))
          (rum/cursor-in app-atom [:prereceiving :stockorder :sticker-confirmed]) {})]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Sticker"
         :right-no-icon true
         :right-plain (cmn/curact app-atom [:prereceiving :stockorder :sticker-confirmed])}))))

(defmethod flow/render-screen :prereceiving/confirm-printed [app-atom _]
  (confirm-printed app-atom))

(defmethod comms/receive :prereceiving/printer-scan [app-atom _]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :prereceiving/confirm-printed))

(defmethod grid/action :prereceiving/printer-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :prereceiving/printer-scan
    {:stockorder_id (get-in @app-atom [:prereceiving :stockorder :id])
     :scan scan}))

(defmethod grid/action :prereceiving/printer-menu-barcode [app-atom _ _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :prereceiving/printer-scan
     :input-key :scan
     :input-type :barcode}))

(defn printer-menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :prereceiving/printer-menu-barcode}

      {:label "Cancel"
       :action :prereceiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defmethod flow/barcode-dispatch-screen :prereceiving/scan-printer [_ app-atom scan]
  (grid/dispatch-action app-atom :prereceiving/printer-scan {:scan scan}))

(rum/defc scan-printer < rum/reactive [app-atom]
  (let [es-client-order (cmn/curact app-atom [:prereceiving :es-client-order])]
    (w/wrapper app-atom "Prereceiving" {:modal-fn printer-menu-modal :steps ycs-steps :step :scan-printer}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Printer"
         [:span.u-hidden-from-view " - "]
         [:span.heading__subtext (str "and put the stickers on the " (if es-client-order "delivery notes" "invoices"))]]
        grid/barcode-icon]]
      [[:p.paragraph.paragraph--flush.u-text-center.u-margin-top-24
        (str "Remember to put the stickers on the " (if es-client-order "delivery notes" "invoices"))]]

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Printer"
         :right-plain true}))))

(defmethod flow/render-screen :prereceiving/scan-printer [app-atom _]
  (scan-printer app-atom))

(defmethod comms/receive :prereceiving/location-scan [app-atom {:keys [locationbarcode]}]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom
    (if (get-in @app-atom [:prereceiving :es-stockorder?])
      :prereceiving/finished
      :prereceiving/scan-printer))
  (swap! app-atom assoc-in [:prereceiving :locationbarcode] locationbarcode))

(defmethod grid/action :prereceiving/location-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :prereceiving/location-scan
    {:stockorder_id (get-in @app-atom [:prereceiving :stockorder :id])
     :scan scan}))

(defmethod grid/action :prereceiving/location-menu-barcode [app-atom _ _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :prereceiving/location-scan
     :input-key :scan
     :input-type :barcode}))

(defn location-menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :prereceiving/location-menu-barcode}

      {:label "Cancel"
       :action :prereceiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defmethod flow/barcode-dispatch-screen :prereceiving/scan-location [_ app-atom scan]
  (grid/dispatch-action app-atom :prereceiving/location-scan {:scan scan}))

(rum/defc scan-location < rum/reactive [app-atom]
  (w/wrapper app-atom "Prereceiving" {:modal-fn location-menu-modal :steps ycs-steps :step :scan-location}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Location"
       [:span.u-hidden-from-view " - "]
       [:span.heading__subtext "and put the boxes there"]]
      grid/barcode-icon]]
    [[:p.paragraph.paragraph--flush.u-text-center.u-margin-top-24
      "Remember to put the boxes in the location you scanned"]]

    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-text "Scan Location"
       :right-plain true})))

(defmethod flow/render-screen :prereceiving/scan-location [app-atom _]
  (scan-location app-atom))

(defmethod comms/receive :prereceiving/stockorder-update-details [app-atom {:keys [dispatch-key]}]
  (toaster/close-toast app-atom)
  (t/transition-next app-atom dispatch-key))

(defmethod grid/action :prereceiving/stockorder-update-details [app-atom _ _]
  (let [prereceiving-atom (rum/cursor app-atom :prereceiving)
        stockorder (cmn/curact prereceiving-atom :stockorder)
        es-client-order (cmn/curact prereceiving-atom :es-client-order)
        es-invoice (get (:invoice-details-idx es-client-order) (:supplierref stockorder))]
    (cond
      (or
        (nil? es-client-order)
        (and es-client-order es-invoice))
      (let [es-supplier-cost (trf/fromcurrency (:invoice-total-inc-tax es-invoice))]
        (toaster/open-toast app-atom :processing "Saving details" {})
        (comms/send :prereceiving/stockorder-update-details
          {:stockorder
           (u/maybe assoc
             stockorder
             :suppliercost (when (and es-client-order es-invoice) es-supplier-cost))
           :dispatch-key :prereceiving/scan-location}))

      (and es-client-order (not es-invoice))
      (toaster/open-toast app-atom :error "Missing invoice from ES, please contact the ES team" {}))))

(defmethod comms/receive :prereceiving/undo-prereceiving [app-atom _]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :main-menu))

(defmethod grid/action :prereceiving/undo-prereceiving [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :prereceiving/undo-prereceiving
    {:stockorder-id (get-in @app-atom [:prereceiving :stockorder :id])}))

(defmethod grid/action :prereceiving/menu-undo-prereceiving [app-atom _ _]
  (grid/confirm-modal app-atom
    {:title "Undo Prereceiving"
     :text [:p {:class (u/bem :paragraph [:flush])}
            "Are you sure you want to undo prereceiving and revert all details?"]
     :confirm-key :prereceiving/undo-prereceiving
     :confirm-text "Yes" :icon-left :delete :icon-class :3-2 :negative true}))

(defmethod comms/receive :prereceiving/reject [app-atom _]
  (toaster/close-subtle-progress app-atom)
  (grid/dispatch-action app-atom :prereceiving/stockorder-pending {}))

(defmethod grid/action :prereceiving/reject [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [stockorder reject]} (get @app-atom :prereceiving)]
    (comms/send :prereceiving/reject
      {:stockorder-id (:id stockorder)
       :supplier-uuid (get-in reject [:supplier :uuid])
       :boxcount (:boxcount reject)
       :reason (:reason reject)
       :printer scan})))

(defmethod comms/receive :prereceiving/reject-image-uploaded [app-atom e]
  (swap! app-atom update-in [:prereceiving :reject-images]
    (fn [c] (cons e c))))

(defmethod grid/action :prereceiving/reject-image [app-atom config _]
  (let [stockorder-uuid (cmn/curact app-atom [:prereceiving :stockorder :uuid])
        attachment-uuid (u/uuid)]
    (presence/upload-file
      {:filename "stockorder-reject-image.png"
       :filecontents (:baos config)
       :type :stock-order/reject}
      {:response :prereceiving/reject-image-uploaded}
      attachment-uuid
      stockorder-uuid))
  (grid/close-modal app-atom))

(defn details-menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Reject"
       :grid-action :prereceiving/reject-reasons}
      {:label "Undo Prereceiving"
       :action :prereceiving/menu-undo-prereceiving
       :style
       {:full true :large true :negative true
        :icon-left :warning :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :prereceiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defmethod comms/receive :prereceiving/remove-attachment [app-atom {:keys [success]}]
  (when (not success)
    (toaster/open-toast app-atom :error "Failed to remove image" {})))

(defmethod grid/action :prereceiving/remove-image [app-atom config _]
  (comms/send :presence/remove-attachment {:uuid (:uuid config) :response :prereceiving/remove-attachment})
  (swap! app-atom update-in [:prereceiving :stockorder :invoice-images]
    (fn [imgs]
      (remove #(= (:ent/uuid %) (:uuid config)) imgs))))

(rum/defc discard-modal-footer < rum/reactive [app-atom config-atom]
  (let [ent-uuid (cmn/curact config-atom [:config :uuid])]
    [:div
     (grid/button-row
       {:left-text "Cancel"
        :left-fn #(grid/dispatch-modal-action app-atom :prereceiving/discard-cancel)
        :left-no-icon true
        :right-text "Discard"
        :right-style :negative
        :right-fn #(grid/dispatch-modal-action app-atom :prereceiving/remove-image {:uuid ent-uuid})
        :right-no-icon true})]))

(rum/defc discard-modal-body < rum/reactive [_ _]
  [[:h3
    {:class (u/bem :heading [:medium-large])}
    "Discard this image?"]
   [:p.paragraph "This action cannot be undone."]])

(defmethod grid/modal-config :prereceiving/discard-modal [_ _ _]
  {:body discard-modal-body
   :footer discard-modal-footer
   :modal-type :alert})

(defmethod comms/receive :prereceiving/image-uploaded [app-atom e]
  (swap! app-atom update-in [:prereceiving :stockorder :invoice-images]
    (fn [c] (cons e c))))

(defmethod grid/action :prereceiving/image [app-atom config _]
  (let [prereceiving-atom (rum/cursor app-atom :prereceiving)
        stockorder (cmn/curact prereceiving-atom :stockorder)
        es-client-order (cmn/curact prereceiving-atom :es-client-order)
        attachment-uuid (u/uuid)]
    (presence/upload-file
      {:filename (if es-client-order "delivery-note-image.png" "invoice-image.png")
       :filecontents (:baos config)
       :type (if es-client-order :stock-order/delivery-note :stock-order/invoice)}
      {:response :prereceiving/image-uploaded}
      attachment-uuid
      (:uuid stockorder)))
  (t/transition-next app-atom :prereceiving/stockorder-details))

(rum/defc stockorder-details < rum/reactive [screen-wrapper app-atom steps app-route-key dispatch-key & [back-key]]
  (let [route-atom (rum/cursor app-atom app-route-key)
        stockorder-atom (rum/cursor route-atom :stockorder)
        {:keys [invoice-images rejectedreason refid suppliername suppliercost itemcount palletcount
                boxcount supplierdate supplierref datearrived photorequired?]}
        (cmn/curact route-atom :stockorder)
        es-client-order (cmn/curact route-atom :es-client-order)]
    (screen-wrapper {:steps steps :step :stockorder-details :modal-fn details-menu-modal}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Enter Details"
         [:span.heading__subtext "YCS" refid]
         [:span.heading__subtext suppliername]
         (when rejectedreason
           [:span.heading__subtext (str "Previously rejected: " rejectedreason)])]

        (forms/input "Number of Boxes:" "3" (rum/cursor-in stockorder-atom [:boxcount])
          {:type :number})

        (forms/input "Number of Pallets:" "0" (rum/cursor-in stockorder-atom [:palletcount])
          {:type :number})

        (forms/input "Number of Items:" "0" (rum/cursor-in stockorder-atom [:itemcount])
          {:type :number})

        (datepicker/datepicker app-atom "Date Arrived:" "dd-mm-yyyy"
          [app-route-key :stockorder :datearrived]
          {:header "Date Arrived"
           :datatype :datedmy})

        (forms/input "Invoice Number:" "IN123456" (rum/cursor-in stockorder-atom [:supplierref]) {})

        (datepicker/datepicker app-atom "Invoice Date:" "dd-mm-yyyy"
          [app-route-key :stockorder :supplierdate]
          {:header "Invoice Date"
           :datatype :datedmy})

        (forms/input "Invoice Amount:" "100.00" (rum/cursor-in stockorder-atom [:suppliercost])
          (u/maybe assoc
            {:type (if es-client-order :hidden :currency)}
            :label-hidden? (when es-client-order true)))

        [:div.form-field.u-max-width-480
         (buttons/button (str "Take pictures of the " (if es-client-order "Delivery Note" "Invoice"))
           #(grid/dispatch-action app-atom :camera/capture-start
              {:callback-action :prereceiving/image})
           {:secondary true
            :bordered true
            :large true
            :full true
            :icon-left :camera})]
        [:div.form-field
         (when-not (empty? invoice-images)
           [[:label.form-label
             "Captured pictures:"]
            (into
              [:div.flex-grid-group
               {:class (u/bem :flex-grid-group [:flush :align-left])}]
              (map
                (fn [{:keys [doc/public-id doc/file-name] :as file}]
                  [:div
                   {:class (u/bem :flex-grid-block [:m-1-4 :t-1-2])}
                   [:div.flex-grid-content
                    [:img
                     {:class (u/bem :image [:full])
                      :on-click
                      #(grid/open-modal app-atom :prereceiving/discard-modal {:uuid (:ent/uuid file)})
                      :src
                      (u/cloudinary
                        public-id
                        {:h 128
                         :q "auto"
                         :f "auto"}) :alt file-name}]]])
                invoice-images))])]

        (forms/textarea "Notes:"
          (rum/cursor-in stockorder-atom [:notes]))]]
      []
      (grid/pos-call-to-action
        {:left-fn
         (if back-key
           #(grid/dispatch-action app-atom
              back-key {})
           #(t/transition-prev app-atom))
         :right-text "Next"
         :right-fn
         (when
           (and
             (not (str/blank? datearrived))
             (not (str/blank? supplierref))
             (not (str/blank? supplierdate))
             (or
               (pos? boxcount)
               (pos? palletcount)
               (pos? itemcount))
             (or
               es-client-order
               (pos? suppliercost))
             (or
               (= :receiving app-route-key)
               (not (empty? invoice-images))
               (not photorequired?)))
           #(grid/dispatch-action app-atom
              dispatch-key {}))}))))

(defmethod flow/render-screen :prereceiving/stockorder-details [app-atom _]
  (stockorder-details
    (partial w/wrapper app-atom "Prereceiving")
    app-atom ycs-steps :prereceiving
    :prereceiving/stockorder-update-details :prereceiving/stockorder-pending))

(defmethod comms/receive :prereceiving/load-invoice-images [app-atom {:keys [data]}]
  (reset!
    (rum/cursor-in app-atom [:prereceiving :stockorder :invoice-images])
    data))

(defmethod comms/receive :prereceiving/email-delivery-note [app-atom {:keys [success] :as e}]
  (if success
    (toaster/open-toast app-atom :success (str "Delivery note emailed to " (:name e)) {})
    (toaster/open-toast app-atom :error "Failed to email delivery note" {})))

(defmethod grid/action :prereceiving/stockorder-select [app-atom {:keys [stockorder]} _]
  (t/transition-next app-atom :prereceiving/stockorder-details)
  (let [prereceiving-atom (rum/cursor app-atom :prereceiving)
        es-client-orders-idx (cmn/curact prereceiving-atom :es-client-orders-idx)
        es-client-order (get es-client-orders-idx (:id stockorder))]
    (when es-client-order
      (comms/send :prereceiving/email-delivery-note
        {:order-uuid (:uuid es-client-order)})
      (toaster/open-toast app-atom :processing "Emailing delivery note to store" {:closetime 300000}))
    (swap! prereceiving-atom assoc
      :stockorder stockorder
      :es-client-order es-client-order)
    (comms/send :presence/attachment
      {:context-uuid {:ent/uuid (:uuid stockorder)}
       :type (if es-client-order :stock-order/delivery-note :stock-order/invoice)
       :response :prereceiving/load-invoice-images})))

(rum/defc order-slat < rum/reactive
  [{:keys [suppliername stockorder-type customer-priority? in-expected-week? dateexpected status ordernumber dateadded bulk-ownbox-count rejectedreason]}
   {:keys [on-click]}]
  [:article.slat.return-order-slat
   {:class
    (when-not (stockorder-receivable? stockorder-type in-expected-week?)
      (u/bem :slat [:error :error-bg]))
    :on-click (when on-click on-click)}
   [:h1.return-order-slat__title
    [:span.return-order-slat__order-no ordernumber]
    (when customer-priority?
      [:span {:class (u/bem :pill [:medium :yellow :is-sentencecase :centred])}
       (if (= stockorder-type "Backorder")
         "Customer order backorder"
         "Customer order")])]
   [:ul.return-order-slat__detail-list
    [:li.return-order-slat__detail-item
     [:b
      suppliername]]
    [:li.return-order-slat__detail-item
     [:b "Date Added: "]
     (ud/format-date dateadded "EEE, dd MMM yyyy")]
    [:li.return-order-slat__detail-item
     [:b "Date Expected: "]
     (str
       (ud/format-date dateexpected "EEE, dd MMM yyyy"))]
    (when rejectedreason
      [:li.return-order-slat__detail-item
       [:b.u-text-status-negative "Has been rejected: " rejectedreason]])
    (when (pos? bulk-ownbox-count)
      [:li.return-order-slat__detail-item
       [:b.u-text-status-negative "Has Own Box: " (inflections/pluralize bulk-ownbox-count "Item")]])]
   [:div.return-order-slat__status-wrapper
    [:span.return-order-slat__status
     [(case status
        "Ready"
        :span.u-text-status-success
        :span.u-text-status-warning) [:b status]]]]])

(defn customer-orders-first
  "Customer orders and their backorders ahead of everything else, otherwise in the given order."
  [stockorders]
  (sort-by (complement :customer-priority?) stockorders))

(rum/defc stockorder-list < rum/reactive [app-atom]
  (let [stockorders (customer-orders-first (cmn/curact app-atom [:prereceiving :stockorders]))]
    (w/wrapper app-atom "Prereceiving" {:steps ycs-steps :step :stockorder-list}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Stockorders"]]
       (map
         (fn [s]
           (rum/with-key
             (order-slat
               s
               {:on-click
                (if (stockorder-receivable? (:stockorder-type s) (:in-expected-week? s))
                  #(grid/dispatch-action app-atom :prereceiving/stockorder-select {:stockorder s})
                  #(toaster/open-toast app-atom :error "Can't pre-receive, outside of expected week!" {}))})
             (:id s)))
         stockorders)]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :prereceiving/stockorder-list [app-atom _]
  (stockorder-list app-atom))

(defmethod comms/receive :prereceiving/stockorder-search
  [app-atom {:keys [stockorders warning es-client-orders es-stockorder?] :as cfg}]
  (toaster/close-toast app-atom)
  (when warning (toaster/open-toast app-atom :warning warning {}))
  (swap! app-atom update :prereceiving assoc
    :es-stockorder? es-stockorder?
    :es-client-orders-idx (u/index-by :linked-yc-stockorder-id es-client-orders)
    :stockorders stockorders)
  (t/transition-next app-atom :prereceiving/stockorder-list))

(defmethod grid/action :prereceiving/stockorder-search [app-atom _ _]
  (toaster/open-toast app-atom :processing "Loading stockorder" {})
  (let [stockorderref (get-in @app-atom [:prereceiving :stockorderref])]
    (comms/send :prereceiving/stockorder-search {:stockorderref stockorderref})))

(defmethod flow/barcode-dispatch-screen :prereceiving/stockorder [_ app-atom scan]
  (toaster/open-subtle-progress app-atom)
  (comms/send :prereceiving/stockorder-search {:stockorderref scan}))

(rum/defc stockorder-search < rum/reactive [app-atom]
  (let [stockorderref-atom (rum/cursor-in app-atom [:prereceiving :stockorderref])]
    (w/wrapper app-atom "Prereceiving" {:steps ycs-steps :step :stockorder}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Enter YCS Number"]
        (forms/input "YCS Number:" "YCS123456" stockorderref-atom)]
       grid/barcode-icon]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (when-not (str/blank? (rum/react stockorderref-atom))
           #(grid/dispatch-action app-atom
              :prereceiving/stockorder-search {}))}))))

(defmethod flow/render-screen :prereceiving/stockorder [app-atom _]
  (stockorder-search app-atom))

(defn transition-stockorder [app-atom]
  (swap! app-atom assoc-in [:prereceiving :stockorderref] nil)
  (t/transition-next app-atom :prereceiving/stockorder))

(rum/defc stockorders-pending < rum/reactive [app-atom]
  (let [pending-stockorders (customer-orders-first (cmn/curact app-atom [:prereceiving :pending-stockorders]))]
    (w/wrapper app-atom "Prereceiving"
      {:steps ycs-steps :step :stockorders-pending :modal-fn details-menu-modal}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str (count pending-stockorders) " Pending Stockorders")]]
       (map
         (fn [stockorder]
           (rum/with-key
             (order-slat
               stockorder
               {:on-click
                (if (stockorder-receivable? (:stockorder-type stockorder) (:in-expected-week? stockorder))
                  #(grid/dispatch-action app-atom :prereceiving/stockorder-select {:stockorder stockorder})
                  #(toaster/open-toast app-atom :error "Can't pre-receive, outside of expected week!" {}))})
             (:id stockorder)))
         pending-stockorders)]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Search"
         :right-fn #(transition-stockorder app-atom)}))))

(defmethod flow/render-screen :prereceiving/stockorder-pending [app-atom _]
  (stockorders-pending app-atom))

(defmethod comms/receive :prereceiving/stockorder-pending
  [app-atom {:keys [stockorders es-client-orders rejectreasons suppliers]}]
  (toaster/close-toast app-atom)
  (swap! app-atom update :prereceiving assoc
    :pending-stockorders stockorders
    :es-client-orders-idx (u/index-by :linked-yc-stockorder-id es-client-orders)
    :stockorder nil
    :suppliers suppliers
    :rejectreasons rejectreasons)
  (t/transition-next app-atom :prereceiving/stockorder-pending))

(defmethod grid/action :prereceiving/stockorder-pending [app-atom _ _]
  (toaster/open-toast app-atom :processing "Loading pending stockorders" {})
  (comms/send :prereceiving/stockorder-pending {}))

(def ibt-steps
  (forms/setup-steps
    [{:key :choose-type :title "Prereceiving Type"}
     {:key :waybill-list :title "List of Waybills to Receive"}
     {:key :waybill :title "Scan IBT Waybill"}
     {:key :items :title "Scan Items"}
     {:key :confirm :title "Confirm"}
     {:key :finished :title "Done"}]))

(rum/defc finished < rum/reactive [app-atom]
  (let [{:keys [waybill stockorder]} (cmn/curact app-atom [:prereceiving])
        ibt? (u/presence (:barcode waybill))]
    (w/wrapper app-atom "Prereceiving" {:steps (if (u/presence (:barcode waybill)) ibt-steps ycs-steps) :step :finished}
      [[:div
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b "Thank you!"]]
        [:i.u-block-center
         {:class (u/bem :icon [:3-3 :emoticon-happy :enormous :block])}]
        [:div.u-margin-top-24
         [:p.u-text-center
          {:class (u/bem :paragraph [:large])}
          [:b
           (if ibt?
             (str "Waybill " (:barcode waybill))
             (str "YCS" (:refid stockorder)))
           [:br]
           "has been pre-received"]]
         [:p.u-text-center
          {:class (u/bem :paragraph [:flush])}
          "You still need to check the stock and receive it properly, but the driver can go."]]]]

      []

      (grid/pos-call-to-action
        {:single-fn #(t/transition-next app-atom (if ibt? :prereceiving/waybill :prereceiving/stockorder))}))))

(defmethod flow/render-screen :prereceiving/finished [app-atom _]
  (finished app-atom))

(defmethod comms/receive :prereceiving/confirm-response [app-atom {:keys [waybill]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :prereceiving assoc :waybill waybill)
  (t/transition-next app-atom :prereceiving/finished))

(defmethod grid/action :prereceiving/confirm [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :prereceiving/confirm
    {:waybill-id (get-in @app-atom [:prereceiving :waybill :id])}))

(rum/defc missing-item-slat < rum/reactive
  [{:keys [qty pname itemtype scanned barcode]}]
  (let [qty (- qty scanned)]
    [:article.slat.product-slat
     [:div.product-slat__qty [:span qty]]
     [:div.product-slat__info
      [:header.product-slat__header
       [:div.product-slat__title-wrapper
        [:h1
         {:class (u/bem :product-slat__title [:small])}
         [:b itemtype]
         (str " " (or pname barcode))]]]]]))

(rum/defc confirm < rum/reactive [app-atom]
  (let [{:keys [waybill items]} (cmn/curact app-atom [:prereceiving])
        itemqty (reduce + 0 (map :qty items))
        packeditemqty (reduce + 0 (map :scanned items))
        missingitems (filter #(not= (:qty %) (:scanned % 0)) items)]
    (w/wrapper app-atom "Prereceiving" {:steps ibt-steps :step :confirm}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str "Confirm " (when (not= itemqty packeditemqty) "Part ") "Fulfillment")
         [:span.heading__subtext (str "from waybill " (:barcode waybill))]]
        [:ul
         {:class (u/bem :order-calc [:fulfillment])}
         [:li.order-calc__item
          [:span.order-calc__item-icon-wrapper
           [:i {:class (u/bem :icon [:truck :block])}]]
          [:span.order-calc__item-name "Items needed:"]
          [:span.order-calc__item-value [:b itemqty]]]
         [:li.order-calc__item
          [:span.order-calc__item-icon-wrapper
           [:i {:class (u/bem :icon [:3-3 :success :block])}]]
          [:span.order-calc__item-name "Items received:"]
          [:span.order-calc__item-value [:b.u-text-status-success packeditemqty]]]
         [:li.order-calc__item
          [:span.order-calc__item-icon-wrapper
           [:i {:class (u/bem :icon [:3-3 :error :block])}]]
          [:span.order-calc__item-name "Items not received:"]
          [:span.order-calc__item-value
           [:b.u-text-status-negative (- itemqty packeditemqty)]]]]]
       (when (not= itemqty packeditemqty)
         [:div
          {:class (u/bem :slats [:items-missing])}
          [:h3.slat.heading-slat
           [:span.heading-slat__icon-wrapper
            [:i {:class (u/bem :icon [:error :block])}]]
           [:span.heading-slat__text "Not received:"]]
          (map missing-item-slat missingitems)])
       [:div.u-margin-bottom-24
        {:class (u/bem :section [:medium])}
        (feedback/action-feedback :truck "Checked" " the waybill item list?"
          (rum/cursor-in app-atom [:prereceiving :waybill :confirmed]) {})]]

      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Confirm"
         :right-style :call-to-action
         :right-no-icon true
         :right-fn
         (when (cmn/curact app-atom [:prereceiving :waybill :confirmed])
           #(grid/dispatch-action app-atom :prereceiving/confirm {}))}))))

(defmethod flow/render-screen :prereceiving/confirm [app-atom _]
  (confirm app-atom))

(defmethod comms/receive :prereceiving/item-scan-response [app-atom {:keys [items item]}]
  (toaster/close-subtle-progress app-atom)
  (let [items (sort-by #(not= (:barcode item) (:barcode %)) items)]
    (if (not items)
      (toaster/open-toast app-atom :error "No items found" {})
      (swap! app-atom assoc-in [:prereceiving :items] items))))

(defmethod grid/action :prereceiving/item-unscan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :prereceiving/item-scan
    {:scan scan
     :unscan? true
     :waybill-id (get-in @app-atom [:prereceiving :waybill :id])}))

(defmethod grid/action :prereceiving/item-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :prereceiving/item-scan
    {:scan scan
     :unscan? false
     :waybill-id (get-in @app-atom [:prereceiving :waybill :id])}))

(defmethod flow/barcode-dispatch-screen :prereceiving/item-list [_ app-atom scan]
  (grid/dispatch-action app-atom :prereceiving/item-scan {:scan scan}))

(defmethod grid/modal-config :prereceiving/modal-item-unscan [_ _ _]
  {:body grid/single-input-modal-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

(defmethod flow/barcode-dispatch-modal :prereceiving/modal-item-unscan [_ app-atom scan]
  (grid/dispatch-modal-action app-atom :prereceiving/item-unscan {:scan scan}))

(defmethod grid/action :prereceiving/menu-unscan [app-atom _ _]
  (grid/open-modal app-atom :prereceiving/modal-item-unscan
    {:scan ""
     :config
     {:title "Unscan Product"
      :field-text "Barcode"
      :initial-value ""
      :save-text "Capture"
      :save-key :prereceiving/item-unscan
      :input-key :scan
      :input-type :barcode}}))

(defmethod grid/action :prereceiving/item-menu-barcode [app-atom _ _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :prereceiving/item-scan
     :input-key :scan
     :input-type :barcode}))

(defn item-list-menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :prereceiving/item-menu-barcode}

      {:label "Unscan Product"
       :action :prereceiving/menu-unscan
       :style
       {:full true :large true :negative true
        :icon-left :delete :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :prereceiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc item-slat < rum/reactive [{:keys [barcode pname itemtype qty scanned]}]
  (let [scanned (or scanned 0)]
    [:article.slat.product-slat.transfer-product-slat
     (cond (= scanned qty) {:class (u/bem :slat [:success])}
       (pos? scanned) {:class (u/bem :slat [:warning])})
     [:div.product-slat__qty.transfer-product-slat__qty
      [:div.transfer-product-slat__count
       [(if (zero? scanned)
          :b.u-text-status-negative
          :b) scanned]
       [:span.u-pipe "of"]
       [:span qty]]]
     [:div.product-slat__info
      [:header.product-slat__header
       [:div.product-slat__title-wrapper
        [:h1.product-slat__title
         [:span.product-slat__brand itemtype]
         pname]]]
      [:ul.product-slat__details
       [:li.product-slat__barcode
        [:b.u-text-spaced-1 barcode]]]]]))

(rum/defc item-list < rum/reactive [app-atom]
  (let [{:keys [waybill items]} (cmn/curact app-atom [:prereceiving])]
    (w/wrapper app-atom "Prereceiving" {:modal-fn item-list-menu-modal :steps ibt-steps :step :items}
      [[:div
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str "Scanned " (count (filter (comp pos? :scanned) items)) " of " (count items) " items")
         [:span.u-hidden-from-view " - "]
         [:span.heading__subtext "from waybill " (:barcode waybill)]]]
       [:div.slats
        (map item-slat items)]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn #(t/transition-next app-atom :prereceiving/confirm)}))))

(defmethod flow/render-screen :prereceiving/item-list [app-atom _]
  (item-list app-atom))

(defmethod comms/receive :prereceiving/waybill-scan-response [app-atom {:keys [waybill items]}]
  (toaster/close-subtle-progress app-atom)
  (cond
    (not waybill)
    (toaster/open-toast app-atom :error "No waybill found" {})

    :else
    (do
      (t/transition-next app-atom :prereceiving/item-list)
      (swap! app-atom update :prereceiving assoc
        :waybill waybill
        :items items))))

(defmethod grid/action :prereceiving/waybill-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :prereceiving/waybill-scan
    {:scan scan}))

(defmethod flow/barcode-dispatch-screen :prereceiving/waybill [_ app-atom scan]
  (grid/dispatch-action app-atom :prereceiving/waybill-scan {:scan scan}))

(defmethod grid/action :prereceiving/waybill-menu-barcode [app-atom _ _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :prereceiving/waybill-scan
     :input-key :scan
     :input-type :barcode}))

(defn waybill-menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :prereceiving/waybill-menu-barcode}

      {:label "Cancel"
       :action :prereceiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc waybill-scan < rum/reactive [app-atom]
  (w/wrapper app-atom "Prereceiving" {:modal-fn waybill-menu-modal :steps ibt-steps :step :waybill}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Waybill Barcode"]
      grid/barcode-icon]]
    [[:aside.page-body__footer
      [:p.u-text-center
       {:class (u/bem :paragraph [:flush])}
       "Scan the waybill barcode to start"]]]
    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-plain true})))

(defmethod flow/render-screen :prereceiving/waybill [app-atom _]
  (waybill-scan app-atom))

(rum/defc list-waybills < rum/reactive [app-atom]
  (let [waybill-list (cmn/curact app-atom [:prereceiving :waybill-list])]
    (w/wrapper app-atom "Prereceiving" {:steps ibt-steps :step :waybill-list}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str (count waybill-list) " Waybills to Receive")]]
       (into [:div.slats]
         (for [waybill waybill-list]
           [:article.slat.transfer-order-slat
            [:header.transfer-order-slat__header
             [:div.transfer-order-slat__title-wrapper
              [:h1.transfer-order-slat__title
               [:span.transfer-order-slat__order-no (:barcode waybill)]
               [:span.transfer-order-slat__user
                (str (:boxqty waybill) " boxes")]]]]]))]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn #(t/transition-next app-atom :prereceiving/waybill)}))))

(defmethod flow/render-screen :prereceiving/list-waybills [app-atom _]
  (list-waybills app-atom))

(defmethod comms/receive :prereceiving/list-waybills [app-atom {:keys [waybill-list]}]
  (toaster/close-toast app-atom)
  (swap! app-atom assoc-in [:prereceiving :waybill-list] waybill-list)
  (t/transition-next app-atom :prereceiving/list-waybills))

(defmethod grid/action :prereceiving/list-waybills [app-atom _ _]
  (toaster/open-toast app-atom :processing "Loading waybills to receive" {})
  (comms/send :prereceiving/list-waybills {}))

(rum/defc choose-type < rum/reactive [app-atom]
  (w/wrapper app-atom "Prereceiving" {:steps ycs-steps :step :choose-type}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Choose Prereceiving Type"]
      [:a.card.tile.u-angled-background.u-bg-teal-blue.u-min-height-160
       {:on-click
        #(grid/dispatch-action app-atom :prereceiving/list-waybills {})}
       [:span.tile__content
        [:span.tile__icon-wrapper
         [:i.tile__icon
          {:class (u/bem :icon [:2-2 :truck-check :large :block])}]]
        [:span.tile__text "IBT Transfer"]]]
      [:a.card.or-card.tile.u-angled-background.u-bg-deep-purple.u-min-height-160
       {:on-click
        #(grid/dispatch-action app-atom :prereceiving/stockorder-pending {})}
       [:span.tile__content
        [:span.tile__icon-wrapper
         [:i.tile__icon
          {:class (u/bem :icon [:2-2 :stocktake :large :block])}]]
        [:span.tile__text "YCS Stockorder"]]]]]
    []
    []))

(defmethod flow/render-screen :prereceiving/choose-type [app-atom _]
  (choose-type app-atom))

(defmethod flow/barcode-dispatch-screen :prereceiving/reject-printer [_ app-atom scan]
  (grid/dispatch-action app-atom :prereceiving/reject {:scan scan}))

(rum/defc reject-printer < rum/reactive [app-atom]
  (w/wrapper app-atom "Prereceiving" {:modal-fn printer-menu-modal :steps ycs-steps :step reject-printer}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Printer"
       [:span.u-hidden-from-view " - "]
       [:span.heading__subtext "and put the stickers on the boxes"]]
      grid/barcode-icon]]
    [[:p.paragraph.paragraph--flush.u-text-center.u-margin-top-24
      "Remember to put the stickers on the boxes"]]

    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-text "Scan Printer"
       :right-plain true})))

(defmethod flow/render-screen :prereceiving/reject-printer [app-atom _]
  (reject-printer app-atom))

(rum/defc reject-reasons < rum/reactive [app-atom]
  (let [rejectreasons (cmn/curact app-atom [:prereceiving :rejectreasons])
        stockorder (cmn/curact app-atom [:prereceiving :stockorder])
        suppliers (cmn/curact app-atom [:prereceiving :suppliers])
        title
        (if stockorder
          "Reject Stockorder"
          "Reject Unknown Stockorder")]
    (w/wrapper app-atom "Prereceiving"
      {:steps ycs-steps :step :reject-reasons}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         title]

        [:article
         {:class [:card :product-card :u-margin-bottom-24]}

         [:div
          {:class [:flex-grid-group :flex-grid-group--flush]}]]

        (forms/select "Reason:"
          (rum/cursor-in app-atom [:prereceiving :reject :reason])
          (into
            [{:text " - Please Select - " :value ""}]
            (map (fn [v] {:text v :value v}) rejectreasons)))
        (forms/input "Number of Boxes:" "3" (rum/cursor-in app-atom [:prereceiving :reject :boxcount])
          {:type :number})

        (when-not (:id stockorder)
          (forms/form-field "Supplier: (Optional)" {}
            (forms/inline-autocomplete-select
              [:div.select-wrapper
               (cmn/curact app-atom [:prereceiving :reject :supplier :companyname])]
              suppliers
              {:select-style? true
               :select-fn #(swap! app-atom assoc-in [:prereceiving :reject :supplier] %)
               :item-render-fn :companyname
               :filter-fn #(str/includes? (str/lower-case (:companyname %1)) (str/lower-case %2))})))

        (when (= (cmn/curact app-atom [:prereceiving :reject :reason]) "Damaged boxes")
          [:div.form-field.u-max-width-480
           (buttons/button "Take Pictures of the Damaged Boxes"
             #(grid/dispatch-action app-atom :camera/capture-start
                {:callback-action :prereceiving/reject-image})
             {:secondary true
              :bordered true
              :large true
              :full true
              :icon-left :camera})])]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn #(t/transition-next app-atom :prereceiving/reject-printer)}))))

(defmethod flow/render-screen :prereceiving/reject [app-atom _]
  (reject-reasons app-atom))

(defmethod grid/action :prereceiving/reject-reasons [app-atom _ _]
  (swap! app-atom assoc-in [:prereceiving :reject] nil)
  (t/transition-next app-atom :prereceiving/reject))